// The full-screen pages the timeline editor opens. Each is used both to add (no editId) and to edit (editId set). A picture and a line are items with stages (src/ui/stages), opened on one of them with `step`.
// Contract shared by TimelineEditor (opens them) and the pages (write through useTimeline().update).
import type { ComponentType } from "react";
import { CameraPage } from "./CameraPage";
import { FeelingPage } from "./FeelingPage";
import { LinePage } from "./LinePage";
import { PicturePage } from "./PicturePage";
import "./pages.css";

export { CameraPage, FeelingPage, LinePage, PicturePage };

export type PageKind = "picture" | "camera" | "line" | "feeling";

export type PageProps = {
  t: number;                 // playhead time when opened (adding), or the edited item's time
  editId?: string;           // id of the marker or line being edited; absent when adding
  newId?: string;            // when adding: the id the new marker or line gets, so the page finds it again once it is made
  step?: string;             // a picture or line opened at one of its stages: "overview", or a picture's "picture" / "faces" / "animate", a line's "voice" / "feel" / "camera"
  char?: string;             // character id, when the edited item belongs to a character (or a preselected one)
  onClose(): void;
  onToast(message: string): void;
  onSeek(t: number): void;   // move the playhead to a time once the episode has changed (a new line's start)
  onOpen(kind: PageKind, opts: { t: number; char?: string; editId?: string; step?: string }): void; // open another page over this one; back comes back here (close this one first to replace it)
};

export const PAGES: Record<PageKind, ComponentType<PageProps>> = { picture: PicturePage, camera: CameraPage, line: LinePage, feeling: FeelingPage };
